export default function SourceFilter({
  sources,
  active,
  counts,
  pending = [],
  onChange,
}) {
  const toggle = (key) => {
    if (active.includes(key)) {
      if (active.length === 1) return;
      onChange(active.filter((k) => k !== key));
    } else {
      onChange([...active, key]);
    }
  };

  return (
    <div className="source-filter">
      {sources.map((s) => {
        const isActive = active.includes(s.key);
        const isPending = pending.includes(s.key);
        const count = counts[s.key];
        return (
          <button
            key={s.key}
            type="button"
            className={`chip chip--${s.key} ${isActive ? 'chip--active' : ''}`}
            onClick={() => toggle(s.key)}
          >
            {s.label}
            {isPending ? (
              <span className="chip__spinner" aria-label="loading" />
            ) : count != null ? (
              <span className="chip__count">{count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
